import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('🎉 App instalado com sucesso! Você pode usá-lo offline.');
  },
  onUpdate: (registration) => {
    console.log('🔄 Nova versão disponível! Recarregue a página para atualizar.');
    // Optionally show a toast/notification to user
    if (window.confirm('Nova versão disponível! Deseja atualizar agora?')) {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  }
});
